import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import join from 'lodash/fp/join';

export const getLink = (url, opts = {}) => {
  const params = flow(
    map.convert({ cap: false })((val, key) => `${key}=${val}`),
    join('&'),
  )(opts.params || {});

  return join('?', params ? [url, params] : [url]);
};

const navigate = (url, opts = {}) => {
  window.open(getLink(url, opts), (opts.event && opts.event.ctrlKey) ? '_blank' : '_self');
};
export default navigate;
